<template>
    <div>
        <Leftmenu />
        <Header />
        <div class="content">
            <div class="content-header">Добро пожаловать</div>
        </div>
    </div>
</template>

<style scoped src="../assets/style/main.css"></style>

<script>
import Leftmenu from '@/components/leftmenu.vue'
import Header from '@/components/header.vue'

export default {
    name: 'Main',
    components: {
        Leftmenu, Header
    },
}
</script>